import { render, staticRenderFns } from "./spaceRequestsForm.vue?vue&type=template&id=17320d4d&scoped=true&"
import script from "./spaceRequestsForm.vue?vue&type=script&lang=js&"
export * from "./spaceRequestsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17320d4d",
  null
  
)

export default component.exports